module.exports = __webpack_public_path__ + "static/media/559785_10151447184349316_1346954699_n.103247cf.jpg";